/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileResult } from '../models/ProfileResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProfileService {

    /**
     * Records the acceptance of a specific version of the terms and agreements.
     * @param profileUid The UID of the auth profile.
     * @param termsVersion The version of the terms to accept.
     * @returns any OK
     * @throws ApiError
     */
    public static acceptTerms(
        profileUid: string,
        termsVersion: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/profile/{profileUid}/accept/{termsVersion}',
            path: {
                'profileUid': profileUid,
                'termsVersion': termsVersion,
            },
        });
    }

    /**
     * Retrieve the profile using the authentication UID of the user.  The
     * authentication UID is assigned by Firebase when the user entry is created.
     * If the profile doesn't already exist for the authentication UID, a profile
     * will be created and returned.
     * @returns ProfileResult OK
     * @throws ApiError
     */
    public static getProfile(): CancelablePromise<ProfileResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/profile',
        });
    }

}
